
import './contact.css'
//movie/now_playing?api_key=952736e265df8b8368e4678273be3c15&language=pt-BR
function Contact(){
  
  return(
    <div className="container">
    <h1>Contacto</h1>
    
    </div>
  )
}

export default Contact;